import {Icons} from "./Icons";
import { ReactComponent as IdHorizontalIcon } from '../../../../assets/themes/emerge/icons/identification.svg'
import { ReactComponent as IdVerticalIcon } from '../../../../assets/themes/emerge/icons/passport.svg'
import { ReactComponent as RefreshIcon } from '../../../../assets/icons/arrow-path.svg'
import { ReactComponent as IntPassport } from '../../../../assets/themes/emerge/icons/international-passport.svg'
import { ReactComponent as SelfieIcon } from '../../../../assets/themes/emerge/icons/selfie-icon.svg'
import { ReactComponent as CheckIcon } from '../../../../assets/icons/check.svg'
import { ReactComponent as UserIcon } from '../../../../assets/icons/user.svg'

const EmergeIcons: Icons = {
    idHorizontal: <IdHorizontalIcon/>,
    idVertical: <IdVerticalIcon/>,
    intPassport: <IntPassport/>,
    user: <UserIcon/>,
    check: <CheckIcon/>,
    refresh: <RefreshIcon/>,
    selfie: <SelfieIcon/>
}

export default EmergeIcons